module.exports = __webpack_public_path__ + "img/create_mindmap.1f9258a6.svg";